import React, { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useThemeSettings } from '../../../ThemeProvider';
import getGlobalStyles from '../../../globalStyles';
import { ButtonVariant, CustomButton } from '../../../components/CustomButton';
import ThinkOLogo from '../../../components/ThinkoLogo';
import { MODAL_MAX_WIDTH } from '../../../shared/constants/dimension';

type InstallAppPromptModalProps = {
  storeUrl?: string;
  onContinue: () => void;
};

const InstallAppPromptModal = ({ storeUrl, onContinue }: InstallAppPromptModalProps) => {
  const { t } = useTranslation();
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);
  

  return (
    <View style={styles.wrapper}>
      <View
        style={[
          styles.logoWrap,
          {
            backgroundColor: theme?.colors?.surfaceColor,
            borderColor: theme?.colors?.primaryLight2,
          },
        ]}>
        <ThinkOLogo size={56} thick />
      </View>

      <Text style={[styles.title, { color: theme?.colors?.headerText }]}>
        {t('screens.share.installPrompt.title')}
      </Text>

      <View style={styles.actions}>
        {!!storeUrl && (
          <CustomButton
            variant={ButtonVariant.NORMAL_PRIMARY}
            contentStyle={styles.primaryButtonContent}
            onPress={() => {
              window.location.href = storeUrl;
            }}>
            {t('screens.share.installPrompt.downloadApp')}
          </CustomButton>
        )}
        <CustomButton
          variant={ButtonVariant.TRANSPARENT}
          contentStyle={styles.secondaryButtonContent}
          labelStyle={{ color: theme?.colors?.headerText }}
          onPress={onContinue}>
          {t('screens.share.installPrompt.continueWeb')}
        </CustomButton>
      </View>
    </View>
  );
};

export default InstallAppPromptModal;

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    maxWidth: MODAL_MAX_WIDTH,
    borderRadius: 28,
    paddingTop: 40,
    paddingBottom: 10,
    gap: 6,
    alignItems: 'center',
  },
  logoWrap: {
    position: 'absolute',
    bottom: 140,
    width: 70,
    height: 70,
    borderRadius: 35,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  title: {
    textAlign: 'center',
    marginTop: 0,
    fontSize : 16,
    fontWeight : '500'
  },
  actions: {
    width: '50%',
    marginTop: 10,
  },
  primaryButtonContent: {
    height: 48,
  },
  secondaryButtonContent: {
    height: 36,
  },
});
